import React, { useState } from "react";
import { Button } from "../../components/ui/button";
import { useNavigate } from "react-router-dom";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { groupService } from "../../services";
import { GoPeople } from "react-icons/go";
import { toast } from "react-toastify";
import useUserStore2 from "../../stores/userStore2";
import { useLocation } from "react-router-dom";

const AddGroup = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("general");

  // Form fields
  const [groupName, setGroupName] = useState("");
  const [emails, setEmails] = useState(""); // comma-separated emails
  const [loading, setLoading] = useState(false);
  const { user } = useUserStore2();
  const { communityId } = location.state || {};

  const handleTabSwitch = (tab) => {
    setActiveTab(tab);
  };

  const handleAddGroup = async () => {
    if (!groupName || !emails) {
      alert("Please enter both group name and Group leader emails.");
      return;
    }

    const emailArray = emails
      .split(",")
      .map((email) => email.trim())
      .filter((email) => email !== "");

    const groupLeader = emailArray[0] || "Unknown";

    const payload = {
      EntityId: user.id,
      CommunityId: communityId,
      Name: groupName,
      Description: `Led by ${groupLeader}`,
      Status: "A",
      Emails: emailArray,
    };

    try {
      setLoading(true);
      await groupService.addGroupWithEmails(payload);
      toast.success("🎉 Group Created successfully!", {
        autoClose: 2000,
      });
      navigate(`/group-management/${communityId}`);
    } catch (error) {
      console.error("Group creation failed:", error);
      toast.error("❌ Failed to create group", {
        autoClose: 2000,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col md:flex-row min-h-screen ">
      <div className="flex-1 flex flex-col">
        <div className="p-8 flex flex-col">
          <div className="bg-white shadow p-4 rounded-lg">
            <div className="flex flex-col sm:flex-row justify-between items-center gap-6 mb-6">
              {/* Left Side */}
              <div className="flex items-center gap-4 w-full md:w-auto">
                <div className="flex items-center justify-center w-16 h-16 bg-indigo-500 rounded-full shrink-0">
                  <GoPeople className="text-white w-12 h-12 p-2" />
                </div>

                <div>
                  <h1 className="text-lg font-semibold text-[#111827]">
                    New Group
                  </h1>
                </div>
              </div>

              {/* Right Side Buttons */}
              <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 w-full sm:w-auto md:w-auto">
                <Button
                  variant={"hollowGreen"}
                  onClick={() => navigate("/group-management")}
                  className="w-full text-center sm:w-auto"
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleAddGroup}
                  disabled={loading}
                  className="w-full sm:w-auto"
                >
                  {loading ? "Adding..." : "Add"}
                </Button>
              </div>
            </div>
          </div>

          {/* Tabs Section */}
          <div className="flex">
            <button
              onClick={() => handleTabSwitch("general")}
              className={`relative mt-5 rounded-tl-xl px-3 pr-10 py-3 text-[14px] font-bold ${
                activeTab === "general"
                  ? "text-[#111827] bg-white"
                  : "text-[#14B8A6] bg-[#F0FDFA]"
              }`}
              style={{
                clipPath: "polygon(0 0, 70% 0, 100% 100%, 0% 100%)",
              }}
            >
              General Info
            </button>
          </div>

          {/* Details Section */}
          {activeTab === "general" && (
            // 👇 replace the existing section with this version
            <div className="grid grid-cols-2 gap-8 bg-white shadow rounded-lg rounded-t-none p-6">
              <div className="col-span-2">
                <Label>Group Name</Label>
                <Input
                  type="text"
                  placeholder="Enter Group Name"
                  value={groupName}
                  onChange={(e) => setGroupName(e.target.value)}
                />
              </div>

              <div className="col-span-2">
                <Label>Group Leader Emails (comma-separated)</Label>
                <Input
                  type="text"
                  placeholder="e.g. leader@example.com, leader2@example.com"
                  value={emails}
                  onChange={(e) => setEmails(e.target.value)}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddGroup;
